import { render, staticRenderFns } from "./TpvCallback.vue?vue&type=template&id=1641fef2&"
import script from "./TpvCallback.vue?vue&type=script&lang=js&"
export * from "./TpvCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports